import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';
import { ButtonDirective } from './components/button/button.directive';
import { StateMessageComponent } from './components/state-message/state-message.component';
import { GrowlHostComponent } from './components/growl-host/growl-host.component';
import { AccountService } from './services/account-service/account.service';
import { SessionService } from './services/account-service/session.service';
import { RedirectService } from './services/redirect-service/redirect.service';
import { GrowlService } from './services/ui-feedback/growl.service';
import { currentRouteRequiresAccount } from './guards/account.guard';
import { AppSettingsService } from './services/app-settings.service';
import { RealtimeService } from './services/realtime/realtime.service';
import { NotificationGrowlService } from './services/notifications/notification-growl.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ButtonDirective, StateMessageComponent, GrowlHostComponent],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  // Private variables

  // Public properties

  // Constructors

  constructor(
    public readonly settings: AppSettingsService,
    public readonly session: SessionService,
    private readonly accounts: AccountService,
    private readonly redirects: RedirectService,
    private readonly growls: GrowlService,
    private readonly realtime: RealtimeService,
    private readonly notificationGrowls: NotificationGrowlService,
    private readonly router: Router
  ) {
    this.session.invalidated.pipe(takeUntilDestroyed()).subscribe(() => {
      this.growls.clear();
      if (currentRouteRequiresAccount(this.router)) {
        this.redirects.remember(this.router.url);
        void this.router.navigate(['/login'], { queryParams: this.redirects.queryParams, replaceUrl: true });
      }
    });
  }

  // Public methods

  public ngOnInit(): void {
    if (!this.settings.errorMessage) {
      void this.accounts.restoreSession();
    }
  }

  public reload(): void {
    window.location.reload();
  }

  // Private methods
}
